<div class="logo dark-logo"></div>
